// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2zTY_","title":"FrontImage_title__zR8cN"};